"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ImageTypes$ = exports.ImageTypes$outboundSchema = exports.ImageTypes$inboundSchema = void 0;
exports.imageTypesToJSON = imageTypesToJSON;
exports.imageTypesFromJSON = imageTypesFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.ImageTypes$inboundSchema = z.object({
    bathroom: z.nullable(z.array(z.string())),
    bedroom: z.nullable(z.array(z.string())),
    conservatory: z.nullable(z.array(z.string())),
    dining_room: z.nullable(z.array(z.string())),
    exterior: z.nullable(z.array(z.string())),
    garden: z.nullable(z.array(z.string())),
    kitchen: z.nullable(z.array(z.string())),
    living_room: z.nullable(z.array(z.string())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "dining_room": "diningRoom",
        "living_room": "livingRoom",
    });
});
/** @internal */
exports.ImageTypes$outboundSchema = z.object({
    bathroom: z.nullable(z.array(z.string())),
    bedroom: z.nullable(z.array(z.string())),
    conservatory: z.nullable(z.array(z.string())),
    diningRoom: z.nullable(z.array(z.string())),
    exterior: z.nullable(z.array(z.string())),
    garden: z.nullable(z.array(z.string())),
    kitchen: z.nullable(z.array(z.string())),
    livingRoom: z.nullable(z.array(z.string())),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        diningRoom: "dining_room",
        livingRoom: "living_room",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var ImageTypes$;
(function (ImageTypes$) {
    /** @deprecated use `ImageTypes$inboundSchema` instead. */
    ImageTypes$.inboundSchema = exports.ImageTypes$inboundSchema;
    /** @deprecated use `ImageTypes$outboundSchema` instead. */
    ImageTypes$.outboundSchema = exports.ImageTypes$outboundSchema;
})(ImageTypes$ || (exports.ImageTypes$ = ImageTypes$ = {}));
function imageTypesToJSON(imageTypes) {
    return JSON.stringify(exports.ImageTypes$outboundSchema.parse(imageTypes));
}
function imageTypesFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.ImageTypes$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'ImageTypes' from JSON`);
}
//# sourceMappingURL=imagetypes.js.map